import App from '@containers/App/App';

import '../src/index.scss';

export default App;
